module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value) ? _c('el-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("SIM")]) : _vm._e(), _vm._v(" "), (!_vm.value) ? _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("NÃO")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-269b791d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/YesNo.vue
// module id = 730
// module chunks = 2